import { DEFAULT_TOAST_LIFE } from "../../../../common/EzToast";
import { affiliateServices } from "../../../../services";
import { goBack } from "../../../../utils/gotoback";
import {
  FETCH_AFFILIATE_INIT,
  FETCH_AFFILIATE_LIST,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  INIT_CREATE_AFFILIATE_SCREEN,
  CREATE_AFFILIATE,
  EDIT_AFFILIATE,
  TOAST,
  FETCH_AFFILIATE_DETAIL,
  EXPORT_AFFILIATE,
  AFFILIATE_DD,
  AFFILIATE_SAVE_TABLE_STATE,
  DELETE_AFFILIATE,
  CURRENCY_CODE_DD,
  AFFILIATE_LOCATION_WITH_AFFILIATE_DD,
} from "../../../types/affiliate.type";

export const initializeAffiliateScreen = () => ({ type: FETCH_AFFILIATE_INIT });

export const affiliateFetchStart = (payload) => ({
  type: FETCH_AFFILIATE_LIST.START,
  payload,
});

export const affiliateFetchSuccess = (payload) => ({
  type: FETCH_AFFILIATE_LIST.SUCCESS,
  payload,
});

export const affiliateFetchError = (payload) => ({
  type: FETCH_AFFILIATE_LIST.ERROR,
  payload,
});

export const fetchAffiliate = (payload) => {
  return (dispatch) => {
    dispatch(affiliateFetchStart(payload));
    affiliateServices.fetchAffiliate(payload).then((data) => {
      if (!data.isError) {
        dispatch(affiliateFetchSuccess(data));
      } else {
        dispatch(affiliateFetchError(data));
      }
    });
  };
};

export const setDeleteConfirmationPopupVisibility = (payload) => ({
  type: SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  payload,
});

export const affiliateDetailFetchStart = (payload) => ({
  type: FETCH_AFFILIATE_DETAIL.START,
  payload,
});

export const affiliateDetailFetchSuccess = (payload) => ({
  type: FETCH_AFFILIATE_DETAIL.SUCCESS,
  payload,
});

export const affiliateDetailFetchError = (payload) => ({
  type: FETCH_AFFILIATE_DETAIL.ERROR,
  payload,
});

export const fetchAffiliateById = (payload) => {
  return (dispatch) => {
    dispatch(affiliateDetailFetchStart(payload));

    affiliateServices.fetchAffiliateById(payload).then((data) => {
      if (!data.isError) {
        dispatch(affiliateDetailFetchSuccess(data));
      } else {
        dispatch(affiliateDetailFetchError(data));
      }
    });
  };
};

export const createAffiliateScreenInitStart = (payload) => ({
  type: INIT_CREATE_AFFILIATE_SCREEN,
  payload,
});

export const initCreateAffiliateScreen = (payload) => {
  return (dispatch) => {
    dispatch(createAffiliateScreenInitStart());
  };
};

export const createAffiliateStart = () => ({
  type: CREATE_AFFILIATE.START,
});

export const createAffiliateSuccess = (payload) => ({
  type: CREATE_AFFILIATE.SUCCESS,
  payload,
});

export const createAffiliateError = (payload) => ({
  type: CREATE_AFFILIATE.ERROR,
  payload,
});

export const resetToast = (payload) => ({
  type: TOAST.RESET,
  payload,
});

export const createAffiliate = (payload) => {
  return (dispatch) => {
    dispatch(createAffiliateStart());
    affiliateServices.createAffiliate(payload).then((data) => {
      if (!data.isError) {
        dispatch(createAffiliateSuccess());
        goBack();
      } else {
        dispatch(createAffiliateError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const editAffiliateStart = (payload) => ({
  type: EDIT_AFFILIATE.START,
  payload,
});

export const editAffiliateSuccess = (payload) => ({
  type: EDIT_AFFILIATE.SUCCESS,
  payload,
});

export const editAffiliateError = (payload) => ({
  type: EDIT_AFFILIATE.ERROR,
  payload,
});

export const editAffiliate = (payload) => {
  return (dispatch) => {
    dispatch(editAffiliateStart());
    affiliateServices.editAffiliate(payload).then((data) => {
      if (!data.isError) {
        dispatch(editAffiliateSuccess());
        dispatch(fetchAffiliateById({ id: payload.id }));
      } else {
        dispatch(editAffiliateError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const exportAffiliateRecordStart = (payload) => ({
  type: EXPORT_AFFILIATE.START,
  payload,
});

export const exportAffiliateRecordSuccess = (payload) => ({
  type: EXPORT_AFFILIATE.SUCCESS,
  payload,
});

export const exportAffiliateRecordError = (payload) => ({
  type: EXPORT_AFFILIATE.ERROR,
  payload,
});

export const exportAffiliate = (payload) => {
  return (dispatch) => {
    dispatch(exportAffiliateRecordStart());
    affiliateServices.exportAffiliateRecord(payload).then((data) => {
      if (!data.isError) {
        dispatch(exportAffiliateRecordSuccess(data));
      } else {
        dispatch(exportAffiliateRecordError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const affiliateDDFetchStart = (payload) => ({
  type: AFFILIATE_DD.START,
  payload,
});

export const affiliateDDFetchSuccess = (payload) => ({
  type: AFFILIATE_DD.SUCCESS,
  payload,
});

export const affiliateDDFetchError = (payload) => ({
  type: AFFILIATE_DD.ERROR,
  payload,
});

export const fetchAffiliateDD = (payload) => {
  return (dispatch) => {
    dispatch(affiliateDDFetchStart(payload));
    affiliateServices.fetchAffiliateDropdown(payload).then((data) => {
      if (!data.isError) {
        dispatch(affiliateDDFetchSuccess(data));
      } else {
        dispatch(affiliateDDFetchError(data));
      }
    });
  };
};

export const affiliateDeleteStart = (payload) => ({ type: DELETE_AFFILIATE.START, payload });
export const affiliateDeleteSuccess = (payload) => ({ type: DELETE_AFFILIATE.SUCCESS, payload });
export const affiliateDeleteError = (payload) => ({ type: DELETE_AFFILIATE.ERROR, payload });

export const deleteAffiliate = (payload) => {
  return (dispatch) => {
    dispatch(affiliateDeleteStart(payload));
    affiliateServices
      .deleteAffiliate(payload)
      .then((data) => {
        if (!data.isError) {
          dispatch(affiliateDeleteSuccess(data));
          dispatch(fetchAffiliate({ ...payload?.params }));
        } else {
          dispatch(affiliateDeleteError(data));
        }
      });
  };
};

export const saveAffiliateTableState = (payload) => ({
  type: AFFILIATE_SAVE_TABLE_STATE,
  payload,
});

export const currencyCodeDDFetchStart = () => ({
  type: CURRENCY_CODE_DD.START,
});

export const currencyCodeDDFetchSuccess = (payload) => ({
  type: CURRENCY_CODE_DD.SUCCESS,
  payload,
});

export const currencyCodeDDFetchError = (payload) => ({
  type: CURRENCY_CODE_DD.ERROR,
  payload,
});

export const fetchCurrencyCodeDD = () => {
  return (dispatch) => {
    dispatch(currencyCodeDDFetchStart());
    affiliateServices.fetchCurrencyCodeDropdown().then((data) => {
      if (!data.isError) {
        dispatch(currencyCodeDDFetchSuccess(data));
      } else {
        dispatch(currencyCodeDDFetchError(data));
      }
    });
  };
};

export const affiliateLocationWithAffiliateDDFetchStart = () => ({
  type: AFFILIATE_LOCATION_WITH_AFFILIATE_DD.START,
});

export const affiliateLocationWithAffiliateDDFetchSuccess = (payload) => ({
  type: AFFILIATE_LOCATION_WITH_AFFILIATE_DD.SUCCESS,
  payload,
});

export const affiliateLocationWithAffiliateDDFetchError = (payload) => ({
  type: AFFILIATE_LOCATION_WITH_AFFILIATE_DD.ERROR,
  payload,
});

export const fetchAffiliateLocationWithAffiliateDD = (affiliateId = null) => {
  return (dispatch) => {
    dispatch(affiliateLocationWithAffiliateDDFetchStart());
    affiliateServices.fetchLocationWithAffiliateDropdown(affiliateId).then((data) => {
      if (!data.isError) {
        dispatch(affiliateLocationWithAffiliateDDFetchSuccess(data));
      } else {
        dispatch(affiliateLocationWithAffiliateDDFetchError(data));
      }
    });
  };
};
